export default function PageTitle({ title }: { title: string }) {
    return (
        <div className="w-full py-10 pb-14 bg-[#1e2939] px-4">
            <div className="mx-auto max-w-7xl text-gray-100 flex items-center justify-between">
                <h1 className="font-bold text-3xl">{title}</h1>
            </div>
        </div>
    )
}
